import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import withAuth, { withAuthPropType } from '../withAuth';
import { getCurrencyStore } from './service';

export const withCurrencyPropType = PropTypes.shape({
  currency: PropTypes.string.isRequired,
  changeCurrency: PropTypes.func.isRequired
});

const withCurrency = WrappedComponent => {
  class WithCurrencyProvider extends Component {
    static propTypes = {
      auth: withAuthPropType.isRequired
    };

    constructor(props) {
      super(props);
      // Get the country from the Auth Object
      const {
        auth: {
          me: {
            activeOrganization: {
              primaryBusinessAddress: { country }
            }
          }
        }
      } = this.props ?? {};
      const countryForDropdown = country ?? 'CA';
      // Set the country for the dropdown
      getCurrencyStore().set('currency', countryForDropdown);

      this.state = {
        currency: countryForDropdown
      };
    }

    changeCurrency = currency => {
      this.setState({ currency });
      getCurrencyStore().set('currency', currency);
    };

    render() {
      const { currency } = this.state;
      return (
        <WrappedComponent currency={currency.toUpperCase()} changeCurrency={this.changeCurrency} {...this.props} />
      );
    }
  }
  return compose(
    withAuth({
      requireAuthentication: true,
      requireAllPermissions: []
    })
  )(WithCurrencyProvider);
};
export default withCurrency;
